import { Component } from '@angular/core';
import { iFrameUrlFactory } from '@utilities/iframe-url-factory';
import { Observable, catchError, map, of, startWith, switchMap, takeUntil, distinctUntilChanged } from 'rxjs';
import { DocViewerTab } from '@enums/doc-viewer-tab.enum';
import { DocViewerStore } from "@store/legacy/doc-viewer.store";
import { BaseComponent } from "../../../base.component";
import { HttpClient } from "@angular/common/http";

@Component({
    selector: 'lex-doc-viewer-translated-content',
    templateUrl: './doc-viewer-translated-content.component.html',
    styleUrls: ['./doc-viewer-translated-content.component.scss'],
    standalone: false
})
export class DocViewerTranslatedContentComponent extends BaseComponent {
	public DocViewerTab = DocViewerTab;
	public url$: Observable<string> = this.docViewerStore.currentDocument$.pipe(
		distinctUntilChanged((a,b) => a.docId === b.docId),
		switchMap((currentDoc) => {
			return this.httpClient.get(
				this.iFrameUrlFactory.buildUrlV2({
					documentId: currentDoc.docId,
					documentView: 'translated',
					shouldHideToolbar: true }),
				{ responseType: 'blob', observe: 'response' }
			).pipe(
				map((result) => URL.createObjectURL(result.body)),
				catchError(() => of(null)),
				startWith(null)
			);
		})
	);
	public isContextPanelResizing: boolean;

	constructor(
		public iFrameUrlFactory: iFrameUrlFactory,
		public docViewerStore: DocViewerStore,
		private httpClient: HttpClient
	) {
		super();
		this.docViewerStore.simpleState$.pipe(
			takeUntil(this.destroy$)
		).subscribe((currentState) => {
			this.isContextPanelResizing = currentState.isContextPanelResizing;
		});
	}

}
